const redirectToSocialMediaPage = (link) => {
    // 👇️ directly change the active URL to navigate
    if (link) {
        window.open(link, "_blank");
    }
};
const camelCaseToCapitalizedWithSpaces = (input) => {
    const formatted = input
        .replace(/_/g, " ") // Replace underscores with spaces
        .split(" ") // Split into words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(" "); // Join back to a string
    return formatted;
};
const objectIsEmpty = (obj) => {
    if (Object.keys(obj).length === 0)
        return true;
    return Object.values(obj).every((value) => !value);
};
const scrollToTop = (element) => {
    // Scroll to the top of the supplied element or page
    if (element) {
        element.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
    else {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
};
const isTimeRangePassed = (timeRange) => {
    const now = new Date();
    // Example input: "08:00 - 09:00"
    const startAndEndTimesArray = timeRange.split(" - ");
    if (startAndEndTimesArray.length !== 2)
        return false;
    const startTimeArray = startAndEndTimesArray[0].split(":");
    const endTimeArray = startAndEndTimesArray[1].split(":");
    if (startTimeArray.length !== 2 || endTimeArray.length !== 2)
        return false;
    const startHour = parseInt(startTimeArray[0]);
    const startMinute = parseInt(startTimeArray[1]);
    const endHour = parseInt(endTimeArray[0]);
    const endMinute = parseInt(endTimeArray[1]);
    if (isNaN(startHour) || isNaN(startMinute) || isNaN(endHour) || isNaN(endMinute)) {
        return false;
    }
    // Subtract 1 hour from the start time
    const startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), startHour, startMinute);
    const currentMinutes = now.getMinutes();
    const minutesToSet = currentMinutes + 30; // Add 30 minutes to current time in order to disable the next time slot.
    now.setMinutes(minutesToSet);
    // If now is before startTime, the time range has passed
    return now < startTime;
};
const capitalizeFirstLetterOfWord = (word) => {
    if (typeof word !== "string" || word.length === 0) {
        return word;
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};
const calculateBasketTotalQuantity = (basket) => {
    let total = 0;
    basket?.product_list?.forEach((item) => {
        const quantity = parseInt(item.quantity, 10);
        total += quantity;
    });
    return total;
};
export { redirectToSocialMediaPage, camelCaseToCapitalizedWithSpaces, objectIsEmpty, scrollToTop, isTimeRangePassed, capitalizeFirstLetterOfWord, calculateBasketTotalQuantity, };
